import { Answer } from "models";
import qs from "query-string";
import { api } from ".";

const url = "/answers";

const answerAPI = api.injectEndpoints({
	endpoints: (build) => ({
		getAnswers: build.query<Answer[], Record<string, any> | undefined>({
			query: (query) => {
				if (query) {
					return `${url}?${qs.stringify(query)}`;
				}
				return url;
			},
		}),
		checkAnswer: build.query<Boolean, Record<string, any>>({
			query: (query) => {
				if (query) {
					return `${url}/checkAnswer?${qs.stringify(query)}`;
				}
				return url;
			},
		}),
		createAnswer: build.mutation<{ status: string }, Record<string, any>>({
			query: (data) => {
				return {
					url,
					method: "POST",
					body: data,
				};
			},
		}),
	}),
});
export const { useLazyGetAnswersQuery, useGetAnswersQuery, useCreateAnswerMutation, useLazyCheckAnswerQuery } = answerAPI;
